

const DIRECTORY_CANDIDATES_DISTRIBUTORS_ROUTES = {
  path: 'directory/candidates/distributors',
  name: 'candidates-distributors',
  component: () => import('@/views/pages/Directories/distributorCandidates/DirectoryDistributorCandidates.vue')
}

export default DIRECTORY_CANDIDATES_DISTRIBUTORS_ROUTES